module.exports = __webpack_public_path__ + "img/wp37.c05489a3.svg";